module.exports = __webpack_public_path__ + "media/images/athletes/1619-e2b019b9310402d818de0730b50638ef.png";